/**
 * スカルプカメラアプリ起動に使用する
 */
export default ({ pin, application, imageUrl }) => {
  const urlScheme = 'shiseido://aramhuvis';
  const universalLink = `${urlScheme}?pin=${pin}&application=${encodeURIComponent(
    application
  )}&posturl=${encodeURIComponent(imageUrl)}`;
  window.location.href = universalLink;

  localStorage.setItem('isSucceededCallScalpCameraApp', 'true');

  return { hasBeenCalledApp: true };
};



// WEBPACK FOOTER //
// ./src/services/camera.js